import { render, staticRenderFns } from "./NavLink.vue?vue&type=template&id=474dfd80&scoped=true"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"
import style0 from "./NavLink.scss?vue&type=style&index=0&id=474dfd80&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474dfd80",
  null
  
)

export default component.exports